import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaLinkedin, FaPaperPlane } from 'react-icons/fa';

const ContactPage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    inquiryType: 'hr_hiring', // 'hr_hiring', 'contract_project', 'general'
    message: ''
  });
  const [statusMsg, setStatusMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const applyTemplate = (templateType) => {
    if (templateType === 'interview') {
      setForm({
        ...form,
        inquiryType: 'hr_hiring',
        message: 'Hello Adedeji,\n\nWe came across your portfolio and are very impressed by your qualifications in Software Engineering / Cloud Infrastructure / Data Analysis / Network Engineering.\n\nWe would like to invite you for an initial interview for an open position at our organization.'
      });
    } else if (templateType === 'project_quote') {
      setForm({
        ...form,
        inquiryType: 'contract_project',
        message: 'Hi Adedeji,\n\nI am interested in hiring you for a contract project (Web Development / Cloud Migration / Network Configuration / Data Dashboard).\n\nPlease let us know your availability and estimated timeline.'
      });
    } else if (templateType === 'consulting') {
      setForm({
        ...form,
        inquiryType: 'contract_project',
        message: 'Hello Adedeji,\n\nWe would like to book a technical consultation regarding our cloud architecture / network security setup.\n\nPlease share your availability for an initial call.'
      });
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatusMsg(null);

    emailjs.sendForm(
      'service_g0tv2ou',
      'template_gtbh1lr',
      formRef.current,
      'j-wDjCtRZXgzIYx45'
    ).then(() => {
      setLoading(false);
      setStatusMsg({ type: 'success', text: 'Thank you! Your message has been sent successfully. Adedeji will respond promptly.' });
      setForm({ name: '', email: '', phone: '', inquiryType: 'hr_hiring', message: '' });
    }, (error) => {
      setLoading(false);
      setStatusMsg({ type: 'error', text: 'Failed to send message automatically. Please email directly to daygme@gmail.com' });
    });
  };

  return (
    <div style={{ background: '#071325', minHeight: '100vh', color: '#ffffff', padding: '60px 24px' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <span className="badge badge-gold" style={{ marginBottom: '12px' }}>
            📫 Direct Inquiry &amp; Booking
          </span>
          <h1 style={{ fontSize: '2.5rem', color: '#ffffff', margin: '8px 0' }}>
            Get in Touch with Adedeji
          </h1>
          <p style={{ color: '#94a3b8', maxWidth: '650px', margin: '0 auto', fontSize: '1.05rem' }}>
            HR hiring inquiries, full-time offers, contract project proposals, and technical consultation requests are welcome.
          </p>
        </div>

        {/* Quick Message Template Presets */}
        <div style={{
          display: 'flex',
          justify: 'center',
          flexWrap: 'wrap',
          gap: '12px',
          marginBottom: '40px'
        }}>

          <button
            onClick={() => applyTemplate('project_quote')}
            style={{
              background: 'rgba(0, 210, 211, 0.15)',
              border: '1px solid #00d2d3',
              color: '#00d2d3',
              padding: '8px 18px',
              borderRadius: '20px',
              fontSize: '0.88rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            💼 Client Preset: Request Contract Quote
          </button>
          <button
            onClick={() => applyTemplate('consulting')}
            style={{
              background: 'rgba(248, 210, 16, 0.15)',
              border: '1px solid #f8d210',
              color: '#f8d210',
              padding: '8px 18px',
              borderRadius: '20px',
              fontSize: '0.88rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            💡 Client Preset: Book Tech Advisory
          </button>
        </div>

        {/* Main Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '40px',
          alignItems: 'flex-start'
        }}>

          {/* Form */}
          <div className="glass-card" style={{ padding: '36px' }}>
            <h3 style={{ fontSize: '1.5rem', color: '#ffffff', marginBottom: '20px' }}>
              Send a Direct Message
            </h3>

            {statusMsg && (
              <div style={{
                padding: '14px',
                borderRadius: '8px',
                marginBottom: '20px',
                backgroundColor: statusMsg.type === 'success' ? 'rgba(46, 204, 113, 0.2)' : 'rgba(231, 76, 60, 0.2)',
                border: `1px solid ${statusMsg.type === 'success' ? '#2ecc71' : '#e74c3c'}`,
                color: statusMsg.type === 'success' ? '#2ecc71' : '#e74c3c',
                fontSize: '0.9rem'
              }}>
                {statusMsg.text}
              </div>
            )}

            <form ref={formRef} onSubmit={sendEmail}>
              
              {/* Inquiry Type Select */}
              <div style={{ marginBottom: '18px' }}>
                <label style={{ display: 'block', color: '#cbd5e1', fontSize: '0.88rem', marginBottom: '6px', fontWeight: '600' }}>
                  Purpose of Inquiry
                </label>
                <select
                  name="inquiryType"
                  value={form.inquiryType}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    background: 'rgba(7, 19, 37, 0.8)',
                    border: '1px solid rgba(69, 170, 242, 0.3)',
                    color: '#ffffff',
                    fontSize: '0.95rem'
                  }}
                >
                  <option value="hr_hiring">👔 HR / Recruiter: Full-Time Position Offer</option>
                  <option value="contract_project">💼 Client: Contract Project / Freelance Build</option>
                  <option value="consulting">💡 Client: Technical Consulting &amp; Advisory</option>
                  <option value="general">💬 General Technical Inquiry</option>
                </select>
              </div>

              {/* Name */}
              <div style={{ marginBottom: '18px' }}>
                <label style={{ display: 'block', color: '#cbd5e1', fontSize: '0.88rem', marginBottom: '6px', fontWeight: '600' }}>
                  Your Name / Organization *
                </label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="e.g. Jane Doe (Tech Recruiter / Company Name)"
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    background: 'rgba(7, 19, 37, 0.8)',
                    border: '1px solid rgba(69, 170, 242, 0.3)',
                    color: '#ffffff',
                    fontSize: '0.95rem'
                  }}
                />
              </div>

              {/* Email */}
              <div style={{ marginBottom: '18px' }}>
                <label style={{ display: 'block', color: '#cbd5e1', fontSize: '0.88rem', marginBottom: '6px', fontWeight: '600' }}>
                  Email Address *
                </label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="name@company.com"
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    background: 'rgba(7, 19, 37, 0.8)',
                    border: '1px solid rgba(69, 170, 242, 0.3)',
                    color: '#ffffff',
                    fontSize: '0.95rem'
                  }}
                />
              </div>

              {/* Message */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', color: '#cbd5e1', fontSize: '0.88rem', marginBottom: '6px', fontWeight: '600' }}>
                  Message Details *
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  rows="5"
                  placeholder="Provide role details or project requirements..."
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    background: 'rgba(7, 19, 37, 0.8)',
                    border: '1px solid rgba(69, 170, 242, 0.3)',
                    color: '#ffffff',
                    fontSize: '0.95rem',
                    lineHeight: '1.5'
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center', fontSize: '1rem', padding: '14px' }}
              >
                {loading ? 'Sending Message...' : <><FaPaperPlane /> Send Message Now</>}
              </button>
            </form>
          </div>

          {/* Direct Contact Information Card */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div className="glass-card" style={{ padding: '32px' }}>
              <h3 style={{ fontSize: '1.4rem', color: '#ffffff', marginBottom: '16px' }}>
                Direct Contact Information
              </h3>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', fontSize: '0.95rem', color: '#cbd5e1' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaEnvelope color="#45aaf2" size={18} />
                  <div>
                    <strong style={{ color: '#ffffff' }}>Email:</strong>{' '}
                    <a href="mailto:daygme@gmail.com" style={{ color: '#45aaf2', textDecoration: 'none' }}>
                      daygme@gmail.com
                    </a>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaPhone color="#2ecc71" size={18} />
                  <div>
                    <strong style={{ color: '#ffffff' }}>Phone:</strong> +358 46 900 0000
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaMapMarkerAlt color="#f8d210" size={18} />
                  <div>
                    <strong style={{ color: '#ffffff' }}>Location:</strong> Finland
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <FaLinkedin color="#00d2d3" size={18} />
                  <div>
                    <strong style={{ color: '#ffffff' }}>LinkedIn:</strong>{' '}
                    <a href="https://linkedin.com/in/adedeji-babalola-9a71aa30" target="_blank" rel="noopener noreferrer" style={{ color: '#00d2d3', textDecoration: 'none' }}>
                      adedeji-babalola
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default ContactPage;
